<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <div class="card-group mb-0">
                        <div class="card p-4">
                            <div class="card-body login-container">
                                <form @submit.prevent.stop="submit" v-debounce ref="form">
                                    <p class="mb-3 font-weight-bold">{{ trans('contacts.actions.reset_password') }}</p>
                                    <form-group :field-parent-classes="'col-12'">
                                        <label slot="label" for="username" class="col-12 col-form-label">{{ trans('contacts.attributes.email_address') }} / {{ trans('contacts.attributes.user_name') }}</label>
                                        <div slot="field" class="input-group">
                                            <span class="input-group-addon"><i class="fa fa-fw fa-at"></i></span>
                                            <input id="username" type="text" class="form-control" ref="focus" v-model="username" autocomplete="off">
                                        </div>
                                    </form-group>
                                    <div class="form-group row has-success" v-if="hasSuccessMessage">
                                        <div class="col-12">
                                            <div class="form-control-feedback" v-html="formattedSuccessMessage"></div>
                                        </div>
                                    </div>
                                    <div class="form-group row has-danger" v-if="hasErrorMessages">
                                        <div class="col-12">
                                            <div class="form-control-feedback" v-html="formattedErrorMessage"></div>
                                        </div>
                                    </div>
                                    <div class="form-group row has-danger" v-if="hasValidationMessages">
                                        <div class="col-12">
                                            <div class="form-control-feedback"
                                                 v-html="formattedValidationMessage"></div>
                                        </div>
                                    </div>
                                    <spinner class="mt-4" v-if="state.loading" slot="field"></spinner>
                                    <div class="mt-4">
                                        <button type="submit" class="btn btn-block btn-primary px-4">
                                            {{ trans('contacts.actions.send_password_reset_link') }}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapState, mapActions} from 'vuex';
    import PasswordEmailController from '@/services/Auth/PasswordEmailController';

    import Spinner from '@/components/Loaders/Spinner';
    import FormGroup from '@/components/Forms/FormGroupHorizontal';

    export default {

        name: 'password-email',

        components: {Spinner, FormGroup},

        data() {
            return {
                username: null,
                email: null,
                state: {
                    loading: false
                }
            };
        },

        mounted() {
            this.setPageTitle(this.trans('contacts.actions.reset_password'));
        },

        computed: {

            ...mapState(['messages']),

            hasValidationMessages() {
                return Object.keys(this.messages.validation).length > 0;
            },
            formattedValidationMessage() {
                return Object.keys(this.messages.validation).reduce((acc, field) => {
                    return `${acc}${acc ? '<br>' : ''}${this.messages.validation[field]}`;
                }, '');
            },

            hasSuccessMessage() {
                return this.messages.success !== '';
            },
            formattedSuccessMessage() {
                return this.messages.success;
            },

            hasErrorMessages() {
                return this.messages.error.length > 0;
            },
            formattedErrorMessage() {
                return this.messages.error[0];
            }

        },

        methods: {

            ...mapActions(['resetMessages', 'swalToast']),

            submit() {
                this.formSubmitShowWait(this.$refs.form);

                this.state.loading = true;

                this.resetMessages();

                PasswordEmailController.sendResetLinkEmail(this.username, this.email).then(response => {
                    this.state.loading = false;
                    this.swalToast({type: 'success', message: response.message});
                }, response => {
                    this.state.loading = false;
                    this.swalToast({type: 'error', message: [response.message]});
                }).finally(() => {
                    this.formSubmitHideWait(this.$refs.form);
                });
            }

        }

    };

</script>



// WEBPACK FOOTER //
// src/views/Auth/PasswordEmail.vue